import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateTimeEntryCategoryRequest, ITimeEntryCategory } from '../models/time-entry-category';

@Injectable({
  providedIn: 'root'
})
export class TimeEntryCategoryService {

  constructor(private http: HttpClient) { }

  searchTimeEntryCategories(request: IBaseSearchRequest = {pageSize: 999999, pageNumber: 0}){
    return this.http.post<IPagedResults<ITimeEntryCategory[]>>(
      `${environment.baseUrl}/v1/TimeEntryCategory/searchTimeEntryCategories`,
      request
    )
  }

  getTimeEntryCategory(id: string){
    return this.http.get<string>(
      `${environment.baseUrl}/v1/TimeEntryCategory/getTimeEntryCategory/${id}`
    )
  }

  createTimeEntryCategory(request: ICreateTimeEntryCategoryRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/TimeEntryCategory/createTimeEntryCategory`,
      request
    )
  }

  updateTimeEntryCategory(request: ITimeEntryCategory){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/TimeEntryCategory/updateTimeEntryCategory/${request.id}`,
      request
    )
  }

  deleteTimeEntryCategory(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/TimeEntryCategory/deleteTimeEntryCategory/${id}`
    )
  }
}
